import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useGameSpace } from '../context/GameSpaceContext';
import {
  ONBOARDING_CHANGE_EVENT,
  dismissGettingStarted as persistDismiss,
  isGettingStartedDismissed,
  isGettingStartedReplay,
  isTipSeen as persistTipSeen,
  markTipSeen as persistMarkTip,
  resetGettingStarted as persistReset,
} from '../utils/onboardingStorage';

export default function useOnboarding() {
  const { currentUserId } = useAuth();
  const { selectedSpaceId } = useGameSpace();
  const [, setVersion] = useState(0);

  useEffect(() => {
    const bump = () => setVersion((value) => value + 1);
    window.addEventListener(ONBOARDING_CHANGE_EVENT, bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener(ONBOARDING_CHANGE_EVENT, bump);
      window.removeEventListener('storage', bump);
    };
  }, []);

  const dismissed = isGettingStartedDismissed(currentUserId, selectedSpaceId);
  const replay = isGettingStartedReplay(currentUserId, selectedSpaceId);

  const dismissGettingStarted = useCallback(() => {
    persistDismiss(currentUserId, selectedSpaceId);
  }, [currentUserId, selectedSpaceId]);

  const resetGettingStarted = useCallback((spaceId) => {
    const targetSpaceId =
      typeof spaceId === 'number' || typeof spaceId === 'string'
        ? spaceId
        : selectedSpaceId;
    persistReset(currentUserId, targetSpaceId);
  }, [currentUserId, selectedSpaceId]);

  const isTipSeen = useCallback(
    (tipId) => persistTipSeen(tipId, currentUserId),
    [currentUserId]
  );

  const markTipSeen = useCallback(
    (tipId) => persistMarkTip(tipId, currentUserId),
    [currentUserId]
  );

  return {
    dismissed,
    replay,
    dismissGettingStarted,
    resetGettingStarted,
    isTipSeen,
    markTipSeen,
  };
}
